/* global _delClass _addClass getElement ActionAdmin _show  _hide Application Primrose _hasClass Parameter Hotels _set Config module*/

// �z�e�����\���ł̃z�e���I��
var HotelOrderResult = {
	initializeFlag: "1",
	lastParams: {},
	ITEM_PER_PAGE: 5,
	selectedHotelNames: {},
	checkedHotel: [], //�`�F�b�N�{�b�N�X�Ń`�F�b�N�����ꂽ�z�e���B������������
	initializeSelectedHotel: function() {
		ActionAdmin.g("Hotels").hotels = [];
	},
	initializeCheckedHotel: function() {
		this.checkedHotel =  [];
	},
	setCheckedHotel: function(hotel_code) {
		var checkedHotel = this.checkedHotel;
		checkedHotel.push(hotel_code);
	},
	removeCheckedHotel: function(hotel_code) {
		var selectHotel = ActionAdmin.g("Hotels").hotels;
		_.pull(selectHotel, hotel_code);
		_.pull(this.checkedHotel, hotel_code);
	},
	setCheckedHotelName: function(hotel_code) {
		var cacheObj = {};
		var cacheCourse = Primrose.getCache("HotelList").hotel;
		for (var i = 0; i < cacheCourse.length; i++) {
			var hotelCode = cacheCourse[i].hotel_code;
			var hotelName = cacheCourse[i].hotel_name;
			cacheObj[hotelCode] = hotelName;
		}
		this.selectedHotelNames[hotel_code] = cacheObj[hotel_code];
	},
	removeCheckedHotelName: function(hotel_code) {
		delete this.selectedHotelNames[hotel_code];
	},
	setHotelSearchCondition: function(checkedHotel) {
		var selectHotel = ActionAdmin.g("Hotels").hotels;
		ActionAdmin.g("Hotels").hotels = _.uniq(selectHotel.concat(checkedHotel));
		this.initializeCheckedHotel();
	},
	setSortToPriceLow: function() {
		//���i�̈����������z�I�ɃN���b�N��
		//sort�̕\�������i���������ɂ���
		//���̊֐����Ō����̎��s�͂����Ȃ�
		var prlow = ActionAdmin.g("sort").members.order_prlow;
		var hotel = ActionAdmin.g("sort").members.order_hotel;
		prlow.onDown(prlow);
		prlow.select();
		hotel._onUp();
	},
	showSingleTourList: function(item) {
		var hotel_code = item.id.split("-")[1];
		this.initializeSelectedHotel();
		this.initializeCheckedHotel();
		this.setCheckedHotel(hotel_code);
		this.setCheckedHotelName(hotel_code);
		this.setHotelSearchCondition(this.checkedHotel);
		this.setSortToPriceLow();
		Application.fireEvent("showTour");
		document.getElementById("sb-hotel").onclick(null, true);
		document.getElementById("result-top").scrollIntoView();
		HotelSortButton.setInfo();
	},
	showMultiTourList: function(item) {
		this.setHotelSearchCondition(this.checkedHotel);
		this.setSortToPriceLow();
		Application.fireEvent("showTour");
		document.getElementById("sb-hotel").onclick(null, true);
		document.getElementById("result-top").scrollIntoView();
		HotelSortButton.setInfo();
	},
	checkHotel: function(e, hotel_code) {
		if (this.initializeFlag === "1") {
			this.initializeSelectedHotel();
			this.initializeCheckedHotel();
			this.initializeFlag = "0";
		}
		var target = getElement("hotelCheckBox-" + hotel_code);
		if (_hasClass(target, "checked")) {
			_delClass(target, "checked");
			_hide("popup-" + hotel_code);
			this.removeCheckedHotel(hotel_code);
			this.removeCheckedHotelName(hotel_code);
		} else {
			_addClass(target, "checked");
			_show("popup-" + hotel_code);
			this.setCheckedHotel(hotel_code);
			this.setCheckedHotelName(hotel_code);
		}
	},
	updateCheckBoxState: function(cassetteInfo) {
		var selectedHotels = ActionAdmin.g("Hotels").hotels;
		var cHotels = this.checkedHotel;
		cHotels = _.uniq(cHotels.concat(selectedHotels));
		_.forEach(cHotels, function(hotel_code) {
			var target = getElement("hotelCheckBox-" + hotel_code);
			if (target) {
				_addClass(target, "checked");
				_show("popup-" + hotel_code);
			}
		});
	},
	getCurrentParams: function() {
		var paramsObj = {};
		var paramList = [];
		paramList = paramList.concat(Parameter.gets());
		paramList = paramList.concat(ActionAdmin.getConditions());
		_.forEach(paramList, function(param) {
			var key = param.split("=")[0];
			var val = param.split("=")[1];
			paramsObj[key] = val;
		});
		return paramsObj;
	},
	isEnable: function(currentParams) {
		//PC, SP���ʊ֐�
		function hasCommonElement(ary1, ary2) {
			if (_.intersection(ary1, ary2).length === 0) {
				return false;
			}
			return true;
		}
		var PARAM_DEF = {
			dist: ["SP_AREA", "AREA0", "region0", "destination", /* area */
				"SP_COUNTRY", "COUNTRY0", "country0", "countryCodes", /*country */
				"SP_CITY", "CITY0", "city0", "cityCodes"/* city */
			],
			dept: ["SP_DEPT", "DEPT", "depAirport"]
		};
		var hasDist = hasCommonElement(PARAM_DEF.dist, Object.keys(currentParams));
		var hasDept = hasCommonElement(PARAM_DEF.dept, Object.keys(currentParams));
		return hasDist && hasDept;
	},
	isHotelSort: function() {
		var currentParams = this.getCurrentParams();
		if (currentParams.sort === "hotel") {
			return true;
		} else {
			return false;
		}
	},
	clear: function() {
		//�z�e�����ɖ߂������������ꍇ�A�I�����Ă����z�e���̏������폜����
		var selected = ActionAdmin.g("Hotels").hotels;
		_.each(selected, function(hotel_code) {
			delete selected[selected.indexOf(hotel_code)];
			delete Hotels.selectedHotelNames[hotel_code];
		});
		HotelSortButton.resetInfo();
	},
	reset: function() {
		this.clear();
		Application.fireEvent("Hotels");
	}

};


var HotelSortButton = {
	setInfo: function() {
		HotelOrderResult.lastParams = HotelOrderResult.getCurrentParams();
	},
	resetInfo: function() {
		HotelOrderResult.lastParams = {};
	},
	compareParams: function(currentParams, lastParams) {
		var cparam = _.clone(currentParams);
		var lparam = _.clone(lastParams);
		var ignoreParam = ["sort", "page"];
		_.forEach(ignoreParam, function(param) {
			delete cparam[param];
			delete lparam[param];
		});
		return _.isEqual(cparam, lparam);
		
	},
	stateControler: function() {
		function isBack() {
			if (Config.params.hotelSort && Config.params.hotelSort === "isBack") {
			//�ڍ׉��ʂ����߂��Ă����ꍇ
				HotelSortButton.setInfo();
				delete Config.params.hotelSort;
				return true;
			} else if (HotelSortButton.compareParams(HotelOrderResult.getCurrentParams(), HotelOrderResult.lastParams)) {
				return true;
			} else {
				return false;
			}
		}
		var currentParams = HotelOrderResult.getCurrentParams();
		Application.ParamHash.hotelSort = "isNotBack";
		if (!HotelOrderResult.isEnable(currentParams)) {
			this.notActive();
		} else {
			if (isBack()) {
				this.back();
				Application.ParamHash.hotelSort = "isBack";
			} else {
				this.active();
			}
		}
	},
	notActive: function() {
		//Toggle group
		var sortMembers = ActionAdmin.g("sort").members;
		sortMembers.order_hotel.isDisabled = true;
		sortMembers.order_hotel2.isDisabled = true;
		//render
		//SP�N���C�A���gJS�̃R���p�C����webpack�𗘗p���Ă��邽�߁ASP���ŃC���N���[�h���Ă����t�@�C���ł�FSP�^�O���g���Ȃ�
		//���s�܂�html�����������ꍇ�́Awebpack��html loader�𗘗p���邱��
		var renderInfo = {tabText: "�z�e����<br><span>���o���n�E�ړI�n���w�肵�Ă��������B</span>"};
		var compiled = _.template('<a href="javascript:;" class="order_hotel disable" style="text-decoration: none;"> <%= tabText %> </a>');
		_set("order_hotel", compiled(renderInfo));
		_set("order_hotel2", compiled(renderInfo));

	},
	active: function() {
		//Toggle group
		var sortMembers = ActionAdmin.g("sort").members;
		sortMembers.order_hotel.isDisabled = false;
		sortMembers.order_hotel2.isDisabled = false;
		//render
		var renderInfo = {tabText: "�z�e����"};
		var compiled = _.template('<a href="javascript:;" class="order_hotel"><%= tabText %></a>');
		_set("order_hotel", compiled(renderInfo));
		_set("order_hotel2", compiled(renderInfo));
	},
	back: function() {
		//Toggle group
		var sortMembers = ActionAdmin.g("sort").members;
		sortMembers.order_hotel.isDisabled = false;
		sortMembers.order_hotel2.isDisabled = false;
		//render
		var renderInfo = {tabText: "�z�e�����ɖ߂�"};
		var compiled = _.template('<a href="javascript:;" class="order_hotel" onclick="HOR.clear()"> <%= tabText %> </a>');
		_set("order_hotel", compiled(renderInfo));
		_set("order_hotel2", compiled(renderInfo));
	}
};

if (typeof module !== "undefined" && module.exports) {
	module.exports = {
		HotelOrderResult: HotelOrderResult,
		HotelSortButton: HotelSortButton
	};
}



// WEBPACK FOOTER //
// ./web/app/hotelOrder.js